module.exports = __webpack_public_path__ + "img/second_image_xueyuan@2x.45e81737.png";